
export default {
  vessel: {
    title: {
      fontSize: '3xl',
      marginBottom: 'sm',
      fontWeight: 'bold',
    },
    content: {
      all: {
        textColor: 'black',
        paddingX: 'sm',
        paddingY: 'lg'
      },
      md: {
        paddingY: '2xl',
        paddingX: 'md'
      },
      xl: {
        paddingY: '3xl',
        paddingRight: '5xl'
      }
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.section = await $content(locale, 'sections/about').fetch()
  },
  data() {
    return {
      section: null
    }
  }
}
